import type { OPENING_CONFIGURATION_TYPE } from '../../admin/experiences/enum/openingConfiguration';
import type { DayOfWeek } from '../enum/dayOfWeek';

export enum PRICE_DIFFERENTIATION_MODE {
  NONE = 'NONE',
  WITH_DAYTIME = 'WITH_DAYTIME',
  WITH_CHILD = 'WITH_CHILD',
  WITH_CHILD_DAYTIME = 'WITH_CHILD_DAYTIME',
}

export type PriceDifferentiationModeType =
  (typeof PRICE_DIFFERENTIATION_MODE)[keyof typeof PRICE_DIFFERENTIATION_MODE];

export enum PRICE_COST_TYPE {
  FREE = 'FREE',
  PAID = 'PAID',
}

export type BasePriceConfiguration = {
  price?: number;
  daytimePrice?: number;
  childPrice?: number;
  childDaytimePrice?: number;
  // Specific for originals
  negotiatedPrice?: number;
  staycationPrice?: number;
};

type DayOfWeekPriceConfiguration = Partial<
  Record<DayOfWeek, BasePriceConfiguration>
>;

export type PriceConfigurationType =
  | {
      type: OPENING_CONFIGURATION_TYPE.CONSTANT;
      configuration: BasePriceConfiguration;
      cost?: PRICE_COST_TYPE;
      priceDifferentiationMode: PriceDifferentiationModeType;
    }
  | {
      type: OPENING_CONFIGURATION_TYPE.DAILY;
      days: DayOfWeekPriceConfiguration;
      cost?: PRICE_COST_TYPE;
      priceDifferentiationMode: PriceDifferentiationModeType;
    };
